<template>
  <div style="display: inline-block">
    <el-button size="mini" type="primary" @click="uploadOk" style="display: inline-block">上传</el-button>
    <div v-dialogDrag>
      <el-dialog v-model="fileInfoDlgVisible" title="资料上传" :before-close="handleClose" destroy-on-close
                 width="500px">
        <template #default>
          <el-form ref="form" :model="form" label-width="120px" v-if="use=='mater'" class="fromSon">
            <el-form-item label="开发部：">
              <el-cascader
                  v-model="form.qk"
                  placeholder="选择开发部"
                  :options="qkSelOptions_kfb"
                  :show-all-levels="false"
                  @change="qkSelChange"
                  filterable
              />
            </el-form-item>
            <el-form-item label="资料名称：">
              <el-input v-model="form.uploadName" clearable placeholder="请填写名称" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="类型：">
              <el-select v-model="form.lx">
                <el-option
                    v-for="item in dynamicTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="附件评价：">
              <el-select v-model="form.remark">
                <el-option
                    v-for="item in dynamicEvaluateList.mater"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"/>
              </el-select>
            </el-form-item>
            <el-form-item label="提交人：">
              <el-input v-model="form.tjyh" clearable placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="提交时间：">
              <el-date-picker
                  v-model="form.tjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="创建人：">
              <el-input v-model="form.cjr" clearable placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-date-picker
                  v-model="form.cjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="说明：">
              <el-input type="textarea" :rows="3" v-model="form.explain" style="width: 220px"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form" :model="form" label-width="120px" v-else-if="use=='produce'" class="fromSon">
            <el-form-item label="开发部：">
              <el-cascader
                  v-model="form.qk"
                  placeholder="选择开发部"
                  :options="qkSelOptions_kfb"
                  :show-all-levels="false"
                  @change="qkSelChange"
                  filterable
              />
            </el-form-item>
            <el-form-item label="安全事故名称：">
              <el-input v-model="form.uploadName" clearable placeholder="请填写名称" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="事故发生日期：">
              <el-date-picker
                  v-model="form.cjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="事故级别：">
              <el-select v-model="form.remark">
                <el-option
                    v-for="item in dynamicEvaluateList.produce"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"/>
              </el-select>
            </el-form-item>
            <el-form-item label="提交人：">
              <el-input v-model="form.tjyh" clearable placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="提交时间：">
              <el-date-picker
                  v-model="form.tjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="说明：">
              <el-input type="textarea" :rows="3" v-model="form.explain" style="width: 220px"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form" :model="form" label-width="120px" v-else-if="use=='tackle'" class="fromSon">
            <el-form-item label="开发部：">
              <el-cascader
                  v-model="form.qk"
                  placeholder="选择开发部"
                  :options="qkSelOptions_kfb"
                  :show-all-levels="false"
                  @change="qkSelChange"
                  filterable
              />
            </el-form-item>
            <el-form-item label="攻关申请课题：">
              <el-input v-model="form.uploadName" clearable placeholder="请填写名称" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="申请人：">
              <el-input v-model="form.tjyh" clearable placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="申请时间：">
              <el-date-picker
                  v-model="form.tjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="申请说明：">
              <el-input type="textarea" :rows="3" v-model="form.explain" style="width: 220px"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form" :model="form" label-width="120px" v-else-if="use=='scheme'" class="fromSon">
            <el-form-item label="开发部：">
              <el-cascader
                  v-model="form.qk"
                  placeholder="选择开发部"
                  :options="qkSelOptions_kfb"
                  :show-all-levels="false"
                  @change="qkSelChange"
                  filterable
              />
            </el-form-item>
            <el-form-item label="资料名称：">
              <el-input v-model="form.uploadName" clearable placeholder="请填写名称" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="提交人：">
              <el-input v-model="form.tjyh" clearable placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="提交时间：">
              <el-date-picker
                  v-model="form.tjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="创建人：">
              <el-input v-model="form.cjr" clearable placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-date-picker
                  v-model="form.cjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="说明：">
              <el-input type="textarea" :rows="3" v-model="form.explain" style="width: 220px"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form" :model="form" label-width="120px" v-else-if="true" :rules="rules">
            <el-form-item label="单位：" prop="qk">
              <el-cascader
                  :props="props1"
                  v-model="form.qk"
                  placeholder=""
                  :options="qkSelOptions"
                  :show-all-levels="false"
                  @change="qkSelChange"
                  filterable
              />
              <!--          <el-cascader-->
              <!--              :props="props1"-->
              <!--              v-model="form.qk"-->
              <!--              placeholder="东河1"-->
              <!--              :options="qkSelOptions"-->
              <!--              :show-all-levels="false"-->
              <!--              @change="qkSelChange"-->
              <!--              filterable-->
              <!--          />-->
            </el-form-item>
            <el-form-item label="类型：" prop="lx">
              <el-cascader
                  v-model="form.lx"
                  :placeholder="myPlaceholder"
                  :options="wdlxSelOptions"
                  filterable
              />
            </el-form-item>
            <el-form-item label="*文件：" prop="inputFile">
              <el-input v-model="inputFile" name="file" ref="file" type="file" multiple style="width: 220px"/>
            </el-form-item>
            <el-form-item label="规范文件名：" v-if="use != 'Work'" prop="cjr">
              <el-input v-model="form.gfWdName" placeholder="Boris" style="width: 220px"/>
              <el-checkbox v-model="form.useSrcName" >保留原始文件名</el-checkbox>
            </el-form-item>
            <el-form-item label="提交人：" v-if="use != 'Work'">
              <el-input v-model="form.tjr" placeholder="Boris" style="width: 220px" :disabled="true"/>
            </el-form-item>
            <el-form-item label="提交人：" v-if="use == 'Work'">
              <el-input v-model="form.tjyh" readonly placeholder="form.tjyh" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="提交时间：" v-if="use != 'Work'">
              <el-date-picker
                  v-model="form.tjsj"
                  type="datetime"
                  placeholder="Select date and time"
                  :disabled="true"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="提交时间：" v-if="use == 'Work'">
              <el-date-picker
                  v-model="form.tjsj"
                  readonly
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="编制人：" v-if="use != 'Work'" prop="cjr">
              <el-input v-model="form.cjr" placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="编制年度：" v-if="use != 'Work'" prop="cjsj">
              <el-date-picker
                  v-model="form.cjsj"
                  type="year"
                  value-format="YYYY"
                  placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
<!--            <el-form-item label="保密级别：" v-if="use != 'Work'">-->
<!--              <el-radio v-model="form.radio1" label="1">低</el-radio>-->
<!--              <el-radio v-model="form.radio1" label="2">中</el-radio>-->
<!--              <el-radio v-model="form.radio1" label="3">高</el-radio>-->
<!--            </el-form-item>-->
            <el-form-item label="关联井号：" v-if="use != 'Work'">
              <el-select v-model="form.value" filterable clearable multiple placeholder="Select">
                <el-option
                    v-for="item in welldata"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span>{{ currentUploadFileName }}</span>
          <el-progress :percentage="progressPercent" status="progressStatus" v-if="progressVisible"/>
        </template>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="fileInfoDlgVisible = false">取消</el-button>
            <el-button type="primary" @click="uploadFile">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessage, ElMessageBox} from "element-plus";
import {v4 as uuidv4} from "uuid";
import {hex_md5} from '../../public/static/js/md5.js'
import {_10to62} from '../../public/static/js/util.js'
// let m_file;

export default {
  name: "docFileUploader",
  mounted: function () {
    let _this = this;
    this.$nextTick(() => {
      switch (_this.use) {
        case "Doc":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/upload";
          _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/wdljgxData";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateInfo";
          break;
        case "Tj":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/uploadtj";
          _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/tjljgxData";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updatetjInfo";
          break;
        case "Gq":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/uploadgq";
          _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/gqljgxData";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updategqInfo";
          break;
        case "Excel":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/uploadExcel";
          _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/wdljgxData";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateExcelInfo";
          break;
       case "Work":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/workExcel";
          _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/workData";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateWorkInfo";
          break;
       case "mater":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/materialFile";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateMaterialInfo";
          break;
       case "produce":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/produceExcel";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateProduceInfo";
          break;
       case "tackle":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/tackleExcel";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateTackleInfo";
          break;
       case "scheme":
          _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/schemeExcel";
          _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateSchemeInfo";
          break;
      }
      this.fetchQKData();
      this.fetchWDLXData();
      // this.fileInfoDlgVisible= this.useDiolog
    })
  },
  methods: {
    getgfWdName(){
      let gfwdName = ""
      if(this.fileInfoDlgVisible && this.use != 'Work'){
        if(this.form.cjsj != null){
          gfwdName=this.form.cjsj;
        }
        if(this.form.qk !=null && this.form.qk.length>0){
          for(let qkrootIdx in this.qkSelOptions){
            let qkroot = this.qkSelOptions[qkrootIdx]
            if(this.form.qk[0].length>1) {
              if (qkroot.BLOCK_ID == this.form.qk[0]) {
                gfwdName += qkroot.label;
                if (this.form.qk.length > 1) {
                  for (let qkchildIdx in qkroot.children) {
                    let qkchild = qkroot.children[qkchildIdx]
                    if (qkchild.BLOCK_ID == this.form.qk[1]) {
                      gfwdName += qkchild.label;
                      if (this.form.qk.length > 2) {
                        for (let qkleafIdx in qkchild.children) {
                          let qkleaf = qkchild.children[qkleafIdx]
                          if (qkleaf.BLOCK_ID == this.form.qk[1]) {
                            gfwdName += qkleaf.label;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            else{
              if (qkroot.BLOCK_ID == this.form.qk) {
                gfwdName += qkroot.label;
              }
            }
          }

        }
        if(this.form.lx !=null && this.form.lx.length>0){
          let wdlx = '';
          for(let qkrootIdx in this.wdlxSelOptions){
            let qkroot = this.wdlxSelOptions[qkrootIdx]
            if(this.form.lx[0].length>1) {
              if (qkroot.value == this.form.lx[0]) {
                // gfwdName += qkroot.label;
                if (this.form.lx.length > 1) {
                  for (let qkchildIdx in qkroot.children) {
                    let qkchild = qkroot.children[qkchildIdx]
                    if (qkchild.value == this.form.lx[1]) {
                      gfwdName += qkchild.label;
                      wdlx = qkroot.label
                      if (this.form.lx.length > 2) {
                        for (let qkleafIdx in qkchild.children) {
                          let qkleaf = qkchild.children[qkleafIdx]
                          if (qkleaf.value == this.form.lx[1]) {
                            gfwdName += qkleaf.label;
                            wdlx = qkroot.label
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            else{
              if (qkroot.value == this.form.qk) {
                gfwdName += qkroot.label;
              }
            }
          }
          if(wdlx.indexOf("方案")>=0){
            if(gfwdName.indexOf("方案")<0){
              gfwdName += "方案"
            }
          }
          else if(wdlx.indexOf("储量")>=0){
            if(gfwdName.indexOf("储量")<0){
              gfwdName += "储量报告"
            }
            else{
              gfwdName += "报告"
            }
          }
          console.log(this.wdlxSelOptions)
        }

      }
      return gfwdName;
    },
    uploadOk() {
      // console.log(document.querySelector('input[type=file]').files)
      // this.thisFiles = this.$refs.file.input.files
      // console.log(this.thisFiles);
      // if (this.thisFiles.length==0){
      //   ElMessage("请选择上传文件！");
      //   return;
      // }
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let userEmpID = '0000001'
      let userName = 'Boris'
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // userEmpID = jsonUserInfo.employeeId;
        userName = jsonUserInfo.displayName;
      }
      this.form.cjr = userName;
      this.form.tjr = userName;
      // this.form.cjsj = new Date();
      this.form.tjsj = new Date();
      this.fileInfoDlgVisible = true;
    },
    //点击上传按钮
    async uploadFile() {
      //表单验证函数，验证不通过则退出
      let isValid=false;
      if(this.$refs.form != undefined) {
        this.$refs.form.validate(valid => {
          console.log(valid)
          isValid = valid;
        })
        if (!isValid) {
          ElMessage("请完善信息！")
          return
        }
      }

      let _this = this;
      //添加是否选择数据的逻辑判断
      if (_this.use=="mater"){
        console.log(_this.form);
        if (_this.form.qk==""){
          ElMessage("请选择区块");
          return;
        }
        if (_this.form.lx==""){
          ElMessage("请选择类型");
          return;
        }
        if (_this.form.remark==""){
          ElMessage("请选择附件评价");
          return;
        }
      }
      if (_this.use=="produce"){
        console.log(_this.form);
        if (_this.form.qk==""){
          ElMessage("请选择区块");
          return;
        }
        if (_this.form.remark==""){
          ElMessage("请选择事故级别");
          return;
        }
      }
      if (_this.use!="mater"&&_this.use!="produce"&&_this.use!="tackle"&&_this.use!="scheme"&&_this.use!="Excel"){
        if (_this.form.qk==""){
          ElMessage("请选择区块");
          return;
        }
        if (_this.form.lx==""){
          ElMessage("请选择类型");
          return;
        }
        console.log(document.querySelector('input[type=file]').files)
        this.thisFiles = this.$refs.file.input.files
        console.log(this.thisFiles);
        if (this.thisFiles.length==0){
          ElMessage("请选择上传文件！");
          return;
        }
      }
      _this.progressVisible = true;
      _this.progressPercent = 0;
      _this.uploadSuccessList = [];
      _this.uploadErrorList = [];
      console.log("开始上传");
      let scLogId = uuidv4();
      scLogId = scLogId.replace("-", "");
      await _this.uploadFileLoop(0, scLogId);
      let qkid = _this.form.qk;
      if(Object.prototype.toString.call(_this.form.qk) == '[object Array]' && _this.form.qk.length > 0){
        qkid = _this.form.qk[_this.form.qk.length - 1];
      }
      await _this.uploadLog(scLogId, _this.form.qk.length > 0 ?  qkid : '', _this.use);
    },
    async uploadFileLoop(fileIdx, scLogId) {
      let _this = this;
      //_this.thisFiles与document.querySelector('input[type=file]').files 不一定相同，需统一
      if (JSON.stringify(_this.thisFiles)=="{}"){
        _this.thisFiles=document.querySelector('input[type=file]').files;
      }
      console.log("thisFiles:",_this.thisFiles,_this.myFiles);
      if(this.myFiles.length>0){
        _this.thisFiles = _this.myFiles
      }
      if (fileIdx < _this.thisFiles.length) {
        _this.progressPercent = 0;
        console.log(fileIdx)
        await _this.uploadSingleFile(scLogId, fileIdx, _this.thisFiles.length).then(function () {
          _this.uploadFileLoop(fileIdx + 1, scLogId);
        });
      }
    },
    //根据上传文件类型，拼接上传内容
    uploadSingleFile: async function (scLogId, curIdx, totalIdx) {
      let _this = this;
      let file = _this.thisFiles[curIdx];

      console.log("file:",file)
      _this.currentUploadFileName = file.name;
      let key = hex_md5(file.name + file.size + file.type + file.lastModified);
      let key10 = parseInt(key, 16);
      let key62 = _10to62(key10);

      let suffixs = _this.suffixs;
      let fileName = file.name;
      let suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase();
      let validateSuffix = false;
      for (let i = 0; i < suffixs.length; i++) {
        if (suffixs[i].toLowerCase() === suffix) {
          validateSuffix = true;
          break;
        }
      }
      if (!validateSuffix) {
        // alert("文件格式不正确！只支持上传：" + suffixs.join(","));
        // // $("#" + _this.inputId + "-input").val("");
        // _this.inputFile = "";
        // return;
      }
      // 文件分片
      // let shardSize = 10 * 1024 * 1024;    //以10MB为一个分片
      // let shardSize = 50 * 1024;    //以50KB为一个分片
      let shardSize = _this.shardSize;
      let shardIndex = 1;		//分片索引，1表示第1个分片
      let size = file.size;
      let shardTotal = Math.ceil(size / shardSize); //总片数
      // console.log("form", _this.form);
      let param = {};
      console.log("curUploadMode:", _this.use);
      console.log("from:",this.form);
      let username = JSON.parse(localStorage.getItem("lyqtUserInfo")).displayName
      switch (_this.use) {
        case "Excel":
          param = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': "excel",
            'excelName': file.name,
            'excelSuffix': suffix,
            'excelSize': file.size,
            'excelKey': key62,
            'flId':'',
            'cjr': username,
            'tjr': username,
            'bmjb': _this.form.radio1,
            'remark': '无',
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': [],
            'fileKey': key62,
            'name': file.name
          }
          break;
        case "Doc":
          param
              = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': _this.use,
            'wdName': this.fileInfoDlgVisible && this.use != 'Work'?(this.form.useSrcName?file.name:this.form.gfWdName):file.name,
            'wdSuffix': suffix,
            'wdSize': file.size,
            'wdKey': key62,
            'flId': _this.form.lx.length > 0 ? _this.form.lx[_this.form.lx.length - 1] : '',
            'cjr': _this.form.cjr,
            'tjr': _this.form.tjr,
            'bmjb': _this.form.radio1,
            'remark': '无',
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': _this.form.value,
            'fileKey': key62,
            'name': file.name
          };
          // _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/upload";
          // _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/wdljgxData";
          // _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updateInfo";
          break;
        case "Tj":
          param
              = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': _this.use,
            'tjName': this.fileInfoDlgVisible && this.use != 'Work'?(this.form.useSrcName?file.name:this.form.gfWdName):file.name,
            'tjSuffix': suffix,
            'tjSize': file.size,
            'tjKey': key62,
            'flId': _this.form.lx.length > 0 ? _this.form.lx[_this.form.lx.length - 1] : '',
            'cjr': _this.form.cjr,
            'tjr': _this.form.tjr,
            'bmjb': _this.form.radio1,
            'remark': '无',
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': _this.form.value,
            'fileKey': key62,
            'name': file.name
          };
          // _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/uploadtj";
          // _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/tjljgxData";
          // _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updatetjInfo";
          break;
        case "Gq":
          param
              = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': _this.use,
            'gqName': this.fileInfoDlgVisible && this.use != 'Work'?(this.form.useSrcName?file.name:this.form.gfWdName):file.name,
            'gqSuffix': suffix,
            'gqSize': file.size,
            'gqKey': key62,
            'flId': _this.form.lx.length > 0 ? _this.form.lx[_this.form.lx.length - 1] : '',
            'cjr': _this.form.cjr,
            'tjr': _this.form.tjr,
            'bmjb': _this.form.radio1,
            'remark': '无',
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': _this.form.value,
            'fileKey': key62,
            'name': file.name
          };
          // _this.uploadUrl = process.env.VUE_APP_SERVER + "/fileprocesser/uploadgq";
          // _this.ljgxUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/gqljgxData";
          // _this.updateInfoUrl = process.env.VUE_APP_SERVER + "/fileprocesser/updategqInfo";
          break;
        case "Work":
          param = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': "Work",
            'gzzjName': file.name,
            'gzzjSuffix': suffix,
            'gzzjSize': file.size,
            'gzzjKey': key62,
            'flId': _this.form.lx.length > 0 ? _this.form.lx[_this.form.lx.length - 1] : '',
            'cjr': username,
            'tjr': username,
            'bmjb': _this.form.radio1,
            'remark': '无',
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': [],
            'fileKey': key62,
            'name': file.name
          }
          break;
        case "mater":
          param = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': "mater",
            'zlpjName': file.name,
            'zlpjSuffix': suffix,
            'zlpjSize': file.size,
            'zlpjKey': key62,
            'flId': _this.form.lx,
            'cjr': username,
            'tjr': username,
            "taskName":_this.form.uploadName,
            "explain":_this.form.explain,
            'bmjb': _this.form.radio1,
            'remark': _this.form.remark,
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': [],
            'fileKey': key62,
            'name': file.name
          };
          break;
        case "produce":
          param = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': "produce",
            'aqscName': file.name,
            'aqscSuffix': suffix,
            'aqscSize': file.size,
            'aqscKey': key62,
            'flId': "",
            'cjr': username,
            'tjr': username,
            "taskName":_this.form.uploadName,
            "explain":_this.form.explain,
            'bmjb': _this.form.radio1,
            'remark':  _this.form.remark,
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': [],
            'fileKey': key62,
            'name': file.name
          };
          break;
        case "tackle":
          param = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': "tackle",
            'ggsqName': file.name,
            'ggsqSuffix': suffix,
            'ggsqSize': file.size,
            'ggsqKey': key62,
            'flId': "",
            'cjr': username,
            'tjr': username,
            "taskName":_this.form.uploadName,
            "explain":_this.form.explain,
            'bmjb': _this.form.radio1,
            'remark':  _this.form.remark,
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': [],
            'fileKey': key62,
            'name': file.name
          };
          break;
        case "scheme":
          param = {
            'shardIndex': shardIndex,
            'shardSize': shardSize,
            'shardTotal': shardTotal,
            'use': "scheme",
            'zlfaName': file.name,
            'zlfaSuffix': suffix,
            'zlfaSize': file.size,
            'zlfaKey': key62,
            'flId': "",
            'cjr': username,
            'tjr': username,
            "taskName":_this.form.uploadName,
            "explain":_this.form.explain,
            'bmjb': _this.form.radio1,
            'remark':  _this.form.remark,
            'cjsj': _this.form.cjsj,
            'tjsj': _this.form.tjsj,
            'scLogId': scLogId,
            'assocWells': [],
            'fileKey': key62,
            'name': file.name
          };
          break;
      }
      if(param.cjsj !=undefined && param.cjsj != null){
        if(param.cjsj.length == 4)
          param.cjsj = param.cjsj+"-01-01"
      }
      console.log("upload:", param);
      await _this.check(param, curIdx, totalIdx);
    },
    async check(param, curIdx, totalIdx) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //查找文件是否已上传
        axios({
          url: process.env.VUE_APP_SERVER + "/fileprocesser/check?key=" + param.fileKey + "&use=" + param.use,
          method: 'GET'
        }).then(async (res) => {
          let resp = res.data;
          if (resp.success) {
            let obj = resp.content;
            console.log("查找文件记录：",resp);
            console.log("文件记录：",obj);
            if (!obj) {
              param.shardIndex = 1;
              console.log("没有找到文件记录，从分片1开始上传");
              await _this.upload(param, curIdx, totalIdx);
            }
            else if (obj.shardIndex === obj.shardTotal) {
              // 已上传分片 = 分片总数，说明已全部上传完，不需要再上传
              // alert("文件极速秒传成功！");
              // _this.fileInfoDlgVisible = false
              // ElMessageBox("文件极速秒传成功！");
              await _this.uploadWithoutFile(param, curIdx, totalIdx);
              // _this.inputFile = "";
            }
            else {
              param.shardIndex = obj.shardIndex + 1;
              console.log("找到文件记录，从分片" + param.shardIndex + "开始上传");
              await _this.upload(param, curIdx, totalIdx);
            }
          }
          else {
            ElMessageBox("文件上传失败");
            // _this.inputFile = "";
            _this.uploadErrorList.push(param.name);
            reject();
          }
          resolve();
          // _this.loading = false;
        })
            .catch((err) => {
          ElMessageBox("文件上传失败");
          // _this.inputFile = "";
          console.log(err);
          _this.uploadErrorList.push(param.name);
          reject();
          // _this.loading = false;
        });
      }).catch((e)=>{console.log("promiseCatch",e)});
    },
    /**
     * 将分片数据转成base64进行上传
     */
    async upload(param, curIdx, totalIdx) {
      let _this = this;
      let shardIndex = param.shardIndex;
      let shardTotal = param.shardTotal;
      let shardSize = param.shardSize;
      let fileShard = _this.getFileShard(shardIndex, shardSize, curIdx);
      let fileReader = new FileReader();

      // _this.loading = true;
      //let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";

      let token = localStorage.getItem("lyqtJwt");
      fileReader.onload = async function (e) {
        return new Promise( (resolve, reject) => {
          let base64 = e.target.result;
          console.log("base64:", base64);

          param.file_Base64 = base64;
          console.log("upload:",param);
          axios.post(_this.uploadUrl,param,{
            headers:{"authorization": "Bearer " + token}
          })
          .then(async (res) => {
            if (res.status === 200){
              let resp = res.data;
              console.log("上传文件成功：",resp);
              _this.$store.state.excelKey = resp.content.excelKey;
              console.log(_this.$store.state.excelKey)
              _this.progressPercent = parseInt(param.shardIndex * 100 / param.shardTotal);
              if (shardIndex < shardTotal) {
                // 上传下一个分片
                console.log("上传下一个分片");
                param.shardIndex = param.shardIndex + 1;
                await _this.upload(param, curIdx, totalIdx);
              }
              else {
                // _this.afterUpload(resp);
                // _this.fileInfoDlgVisible = false
                // _this.afterUpload(resp);
                // ElMessageBox('文件上传成功');
                _this.uploadSuccessList.push(param.name);

                if (curIdx == (totalIdx - 1)) {
                  //根据文件类型将不同参数返回父组件的 afterUpload（）函数
                  if(_this.use =="Excel"){
                    _this.afterUpload(resp.content.excelKey);
                  }
                  else if(_this.use =="Work"){
                      console.log(resp.content.gzzjKey);
                      _this.afterUpload(resp.content.gzzjKey);
                    }
                  else{
                      console.log(_this.uploadSuccessList);
                    _this.afterUpload(_this.uploadSuccessList);
                  }
                  _this.progressPercent = 100;
                  _this.progressStatus = "success";

                  let qkid = _this.form.qk;
                  if(Object.prototype.toString.call(_this.form.qk) == '[object Array]' && _this.form.qk.length > 0){
                    qkid = _this.form.qk[_this.form.qk.length - 1];
                  }
                  await _this.uploadLog(param.scLogId, _this.form.qk.length > 0 ? qkid : '', param.use)
                  if(_this.use != "Excel"&&_this.use != "Work"){
                    // await ElMessageBox('上传文件成功!');
                    await ElMessage.success("上传文件成功!");
                  }
                  _this.progressVisible = false;
                  _this.progressPercent = 0;
                  _this.progressStatus = "";
                  _this.inputFile = "";
                  _this.fileInfoDlgVisible = false
                }

                if(this.use != "Excel"){
                  resolve();
                }
              }
            }
            // _this.loading = false;
          }).catch((err) => {
            ElMessageBox('Error');
            console.log(err)
            // _this.loading = false;
            _this.uploadErrorList.push(param.name);
            reject();
          })
        }).catch((e)=>{console.log("promiseCatch",e)});
      };

      await fileReader.readAsDataURL(fileShard);
    },
    getFileShard(shardIndex, shardSize, curIdx) {
      console.log(curIdx);
      //let file =this.$refs.file.input.files.files[curIdx];
      let file =this.thisFiles[curIdx];
      console.log("file:", file);
      let start = (shardIndex - 1) * shardSize;	//当前分片起始位置
      let end = Math.min(file.size, start + shardSize); //当前分片结束位置
      let fileShard = file.slice(start, end); //从文件中截取当前的分片数据
      return fileShard;
    },
    //插入 上传日志记录表
    async uploadLog(logid, qkid, sclx) {
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let userEmpID = '0000001'
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        userEmpID = jsonUserInfo.employeeId;
      }
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_SERVER + "/fileprocesser/uploadlog?logid=" + logid + "&blockid=" + qkid + "&sclx=" + sclx+"&userid="+userEmpID,
          method: 'GET',
        }).then((res) => {
          if (res.status === 200) {
            console.log("上传日志记录成功：",res);
            resolve();
          }
        }).catch((err) => {
          console.log(err)
          reject();
        })
      }).catch((e)=>{console.log("promiseCatch",e)});
    },
    async uploadWithoutFile(param, curIdx, totalIdx) {
      let _this = this;
      return new Promise((resolve, reject) => {
        axios({
          url: _this.updateInfoUrl,
          method: 'POST',
          data: param
        }).then(async (res) => {
          if (res.status === 200) {
            let resp = res.data;
            let qkid = _this.form.qk;
            if(Object.prototype.toString.call(this.form.qk) == '[object Array]' && _this.form.qk.length > 0){
              qkid = _this.form.qk[_this.form.qk.length - 1];
            }
            await _this.uploadLog(param.scLogId, _this.form.qk.length > 0 ?  qkid : '', param.use);
            console.log("上传文件成功：", resp);
              if(_this.use =="Excel"){
                  _this.$store.state.excelKey = resp.content.excelKey;
              }else if(_this.use == "Work"){
                  _this.$store.state.gzzjKey = resp.content.gzzjKey;
              }
            _this.uploadSuccessList.push(param.name);
            _this.progressPercent = parseInt(param.shardIndex * 100 / param.shardTotal);
            if(curIdx == (totalIdx - 1)) {
              if(_this.use =="Excel"){
                 _this.afterUpload(resp.content.excelKey);
              } else{
                _this.afterUpload(_this.uploadSuccessList);
              }
              _this.progressPercent = 100;
              _this.progressStatus = "success";
              if(this.use !="Excel"){
                // await ElMessageBox('上传文件成功!');
                await ElMessage.success("上传文件成功!");
              }
              _this.progressVisible = false;
              _this.progressPercent = 0;
              _this.progressStatus = "";
              _this.inputFile = "";
              _this.fileInfoDlgVisible = false
            }
            resolve();
            // _this.afterUpload(resp);
          }
        }).catch((err) => {
          ElMessageBox('Error');
          console.log(err);
          _this.uploadErrorList.push(param.name);
          reject();
        })
      }).catch((e)=>{console.log("promiseCatch",e)});
    },
    handleClose(done) {
      ElMessageBox.confirm('是否确认不做任何操作，关闭当前对话框？')
          .then(() => {
            done()
          })
          .catch(() => {
            // catch error
          })
    },
    fetchQKData() {
      let that = this;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData",
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.qkSelOptions = res.data;
          console.log(res);
          //构建开发部列表数据（树形结构），同时将开发部的value值修改为开发部下区块的value值
          let qkSelOptions_kfb=JSON.parse(JSON.stringify(this.qkSelOptions));
          for (let i=0;i<qkSelOptions_kfb[0]["children"].length;i++){
            let kfb=qkSelOptions_kfb[0]["children"][i];
            let qkId=kfb.children[0].children[0].value;
            kfb.value=qkId;//替换value值
            delete kfb.children;//删除开发部下的子节点
          }
          this.qkSelOptions_kfb=qkSelOptions_kfb;
          this.qkSelOptions = this.qkSelOptions[0]["children"];
          this.form.qk = this.qkSelOptions[0].value;
        }
        // that.loading = false;
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
        // that.loading = false;
      })
    },
    fetchWDLXData() {
      let that = this;
      axios({
        url: this.ljgxUrl,
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.wdlxSelOptions = res.data;
          console.log(res);
        }
        // that.loading = false;
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
        // that.loading = false;
      })
    },
    qkSelChange(value) {
      let checkedBlock = [];
      console.log(value);
      if (value.length == 0)
        return;
      checkedBlock.push(value[value.length - 1]);
      let that = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellDataByBlk",
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: checkedBlock
      }).then((res) => {
        if (res.status === 200) {
          that.welldata = res.data;
          console.log(res);
        }
        // that.loading = false;
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
        // that.loading = false;
      })
    }
  },
  props: {
    shardSize: {//15MB
      default: 15 * 1024 * 1024
    },//默认文件单分片大小
    suffixs: {
      default: []
    },
    use: {//上传文件类型
      default: "Doc"
    },
    afterUpload: {//文件上传结束事件
      type: Function,
      default: null
    },
    myFiles:{//上传的文件
      default: []
    },
    useDiolog:{
      default: false
    },
    myPlaceholder:{//上传文件框默认显示内容
        default:"综合治理方案"
    },
    // uploadUrl:{//文件上传后端接口地址
    //   default:process.env.VUE_APP_SERVER + "/fileprocesser/upload"
    // }
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_SERVER + "/fileprocesser/upload",
      ljgxUrl: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/wdljgxData",
      updateInfoUrl: process.env.VUE_APP_SERVER + "/fileprocesser/updateInfo",
      inputFile: "",
      fileInfoDlgVisible: false,
      progressVisible: false,
      currentUploadFileName: "",
      progressPercent: 0,
      progressStatus: "",
      innerVisible: false,
      wdlxSelOptions: [],
      qkSelOptions: [],//区块数据列表（树形结构）
      qkSelOptions_kfb: [],//开发部数据列表（树形结构） 备注：开发部依旧为区块id
      welldata: [],
      uploadSuccessList: [],
      uploadErrorList: [],
      thisFiles:{},
      props1:{
        checkStrictly: true,
      },
      form: {
        qk: '',
        lx: '',
        tjr: 'Boris',
        tjyh:JSON.parse(localStorage.getItem("lyqtUserInfo")).displayName, // 提交人 || 申请人
        tjsj: new Date(), //提交时间 || 申请时间
        cjr: '',
        cjsj: null, //创建时间 || 事故发生日期
        value: '',
        radio1: '1',
        remark:"",//备注 || 附件评价 || 事故级别
        explain:"",//说明 ||申请说明
        uploadName:"",//资料名称 || 事故名称 || 攻关申请课题
        gfWdName:"",//规范文件名称
        useSrcName:true//保留原始文件名称
      },

      dynamicTypeList:[
        {
          value:"sccj",
          label:"生产测井"
        },
        {
          value:"kfsj",
          label:"开发试井"
        }
      ],//类型 列表 ————动态监测资料质量上传
      dynamicEvaluateList: {
        "mater": [
          {
            label: "优"
          },
          {
            label: "良"
          },
          {
            label: "合格"
          },
          {
            label: "不合格"
          },
          {
            label: "不参与评价"
          },
        ],
        "produce": [
          {
            label: "发生一般C级及以上安全事故",
            score:"不得分",
          },
          {
            label: "发生工具串或仪器落井等生产事件",
            score: "-0.5分/次"
          },
          {
            label: "遇阻、遇卡处理周期超过3天",
            score: "-0.2分/次"
          },
          {
            label: "发生生产安全事故事件谎报、瞒报、不报",
            score: "-1分/次"
          },
          {
            label: "作业期间主动发现较大或重大安全隐患，并采取有效控制措施及时消除安全隐患",
            score: "+0.2分/次"
          },
        ],
      },//附件评价 || 事故级别 列表 ————动态监测资料质量，安全生产上传

      rules: {
        qk: [{type: "any", required: true, message: '请选择区块', trigger: 'change',},],
        lx: [{type: "array", required: true, message: '请选择类型', trigger: 'change',},],
        // inputFile: [{type: "string", required: true, message: '请上传文件', trigger: 'change',},],
        cjr: [{type:"string", required: true, message: '请填写编制人', trigger: 'change',},],
        cjsj: [{type: "date",required: true, message: '请选择时间', trigger: 'change',},],
      },//考核新增表单验证规则
    }
  },
  watch: {
    form: {
      handler() {
        if(this.fileInfoDlgVisible && this.use != 'Work') {
          let curGfWdName = this.getgfWdName();
          if (this.form.gfWdName != curGfWdName) {
            console.log(curGfWdName,this.form)
            this.form.gfWdName = curGfWdName;
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.fromSon > .el-form-item {
  margin-top: 5px;
}
</style>